

import React, { memo } from 'react';
import cx from 'classnames';
import arrayMove from 'array-move';

import { Image } from '../../Image';
import Icon from '../../Icon';
import '../styles/_resource-members.scss';

const MAX_PREVIEW_MEMBERS_COUNT = 4;
const OWNER = 'OWNER';
const DEFAULT_IMAGE_SIZE = '40px';
const SMALL_IMAGE_SIZE = '30px';












function ResourceMembers(
{
  members,
  small,
  countSuffix,
  showCount,
  showOwnerBadge,
  onAddIconClick,
  darkMode,
  totalMembers: overrideTotalMembers
}) {
  const totalMembers = overrideTotalMembers !== void 0 ? overrideTotalMembers : members.length;
  const resourceOwnerIndex = showOwnerBadge ?
  members.findIndex(({ role }) => role && role.name === OWNER) :
  -1;

  const membersSummary = resourceOwnerIndex > -1 ?
  arrayMove(members, resourceOwnerIndex, 0).slice(0, MAX_PREVIEW_MEMBERS_COUNT) :
  members.slice(0, MAX_PREVIEW_MEMBERS_COUNT);

  const defaultSuffix = `Viewer${totalMembers === 1 ? '' : 's'}`;
  const imageSize = small ? SMALL_IMAGE_SIZE : DEFAULT_IMAGE_SIZE;

  return (
    <div className={cx('resource-members', { 'resource-members--dark-mode': darkMode })}>
      {onAddIconClick ?

      <div
        className={cx(
          'resource-members__member--add-icon',
          { 'resource-members__member--dark-mode': darkMode }
        )}>

            <Image
          height={imageSize}
          width={imageSize}
          circular
          defaultImageIcon="addfat"
          defaultIconColour="denim"
          backgroundSize="cover"
          onClick={onAddIconClick}
          defaultIconSize={small ? 14 : 18} />

          </div> :
      null}
      {
      membersSummary.map((member, index) => {
        const { userId, teamId, name, firstName, lastName, imageUrl, role } = member;
        const memberName = name || `${firstName} ${lastName}`;
        const showOverlay = totalMembers > MAX_PREVIEW_MEMBERS_COUNT &&
        index === membersSummary.length - 1;

        return (
          <div
            key={userId || teamId}
            className={cx(
              'resource-members__member',
              { 'resource-members__member--with-more': showOverlay },
              { 'resource-members__member--dark-mode': darkMode }
            )}
            style={{ zIndex: totalMembers - index }}>

              <Image
              height={imageSize}
              width={imageSize}
              circular
              imageUrl={imageUrl}
              placeholderText={memberName}
              placeholderTextSize={small ? 10 : 14}
              backgroundSize="cover" />

              {showOwnerBadge && role && role.name === OWNER ?

            <div className="resource-members__member__owner">
                    <Icon name="owner" color="goldenShiny" size={12} />
                  </div> :

            null}
              {showOverlay ?

            <span className="resource-members__member__quantity" style={{ fontSize: small ? 10 : 14 }}>
                    {`+${totalMembers - MAX_PREVIEW_MEMBERS_COUNT}`}
                  </span> :

            null}
            </div>);

      })}

      {showCount ?

      <span className="resource-members__total">
            {`${totalMembers} ${countSuffix || defaultSuffix}`}
          </span> :

      null}
    </div>);

}

ResourceMembers.defaultProps = {
  imageSize: '20px'
};

export default memo(ResourceMembers);